import { ApiClient } from '../../../setup/axios/SetupAxios'
import { ListQueryParams } from '../ApiClient'
import { GetAPIDomain } from '../Helper'

export class SiteQueryParams extends ListQueryParams {
    WithUserId(value: string) {
        this.WithParam('userId', value)
        return this
    }
    WithSiteTypeId(value: string) {
        this.WithParam('siteTypeId', value)
        return this
    }
    WithEnabled(value: boolean) {
        this.WithParam('enabled', value)
        return this
    }
    WithTenantId(value: string) {
        this.WithParam('tenantId', value)
        return this
    }
    WithContractId(value: string) {
        this.WithParam('contractId', value)
        return this
    }
    WithLinked(value: boolean) {
        this.WithParam('isLinked', value)
        return this
    }
}

export class SitesClient {
    static async List(params: SiteQueryParams) {
        return await ApiClient.Get('/sites' + params.GenerateQueryString());
    }

    static async CheckLists(id: string) {
        return await ApiClient.Get('/sites/' + id + '/checklist-templates');
    }

    static async Sync() {
        return await ApiClient.Post('/sites/sync', {});
    }
    
    static async Get(id: string) {
        return await ApiClient.Get('/sites/' + id);
    }
}
